// extracted by mini-css-extract-plugin
export default {"fullscreenBtn":"FullscreenBtn_fullscreenBtn__vtTMz"};